var map = {
	"./4theplayer.svg": "e73f",
	"./app-check.svg": "97a7",
	"./app-five-full-star.svg": "5be0",
	"./app-four-full-star.svg": "67a2",
	"./app-icon-copy.svg": "5fd1",
	"./app-logo.svg": "2405",
	"./arrow-right.svg": "3f8a",
	"./arrow.svg": "1106",
	"./astropay.svg": "b7fc",
	"./auth-chat.svg": "3d75",
	"./belatra.svg": "31ba",
	"./bgaming.svg": "acf1",
	"./bigtimegaming.svg": "82ba",
	"./bitcoin.svg": "ef76",
	"./bonus.svg": "baa7",
	"./booming.svg": "c510",
	"./boominggames.svg": "7b12",
	"./booongo.svg": "32e7",
	"./cards.svg": "ab42",
	"./cashback.svg": "afef",
	"./cashout.svg": "f57a",
	"./categories_nav.svg": "295e",
	"./chat.svg": "9e5a",
	"./check-app.svg": "e8f4",
	"./check.svg": "6aa8",
	"./circle.svg": "869e",
	"./clock.svg": "6e22",
	"./close-app.svg": "eeb6",
	"./coinspaid.svg": "60f1",
	"./cs.svg": "9f8e",
	"./curacao.svg": "b490",
	"./de.svg": "2598",
	"./dice.svg": "429d",
	"./download-app.svg": "0629",
	"./download-image-320.svg": "f7e4",
	"./download-image.svg": "3ad8",
	"./download.svg": "9f0f",
	"./ecashout.svg": "4414",
	"./egt.svg": "a739",
	"./electricelephant.svg": "6ee2",
	"./en-ca.svg": "9f57",
	"./en.svg": "38e4",
	"./endorphina.svg": "d2af",
	"./evolution.svg": "5a36",
	"./ezeewallet.svg": "32df",
	"./fantasmagames.svg": "9d91",
	"./fast.svg": "2476",
	"./five-full-star.svg": "6637",
	"./flower.svg": "1c80",
	"./footer-bg.svg": "1593",
	"./four-full-star.svg": "af9c",
	"./fr.svg": "40b7",
	"./fr_ca.svg": "f172",
	"./gameart.svg": "ccd0",
	"./games.svg": "ccdb",
	"./gaming_book.svg": "dca9",
	"./go.svg": "58a6",
	"./gr.svg": "9afd",
	"./guru.svg": "c6ec",
	"./habanero.svg": "d4d9",
	"./ic_close.svg": "e72c",
	"./icons.svg": "48a6",
	"./idebit.svg": "4a0b",
	"./igtech.svg": "9e79",
	"./instadebit.svg": "5036",
	"./interac-etransfer.svg": "1a3e",
	"./interac-online.svg": "569f",
	"./jeton-logo.svg": "ec5c",
	"./kalamba.svg": "1e38",
	"./klarna.svg": "372a",
	"./lobby_nav.svg": "8dcb",
	"./locked-bonus.svg": "c850",
	"./logo-footer.svg": "7a30",
	"./logo.svg": "1ae4",
	"./maestro.svg": "f29d",
	"./mastercard.svg": "29b8",
	"./maxwingaming.svg": "73a7",
	"./mga.svg": "0f33",
	"./microgaming-white.svg": "0213",
	"./microgaming.svg": "79f4",
	"./muchbetter.svg": "1bbc",
	"./neosurf.svg": "22c4",
	"./neteller.svg": "c604",
	"./netent-white.svg": "35cc",
	"./netent.svg": "dde0",
	"./northernlights.svg": "12a0",
	"./nz.svg": "fba0",
	"./offer-bonus.svg": "8c5c",
	"./offer-games.svg": "e77a",
	"./offer-jackpots.svg": "1950",
	"./offer-live.svg": "2f00",
	"./offer-payment.svg": "7d20",
	"./offer-support.svg": "a34f",
	"./paysafe.svg": "91bd",
	"./platipus.svg": "0b59",
	"./playngo-white.svg": "d64a",
	"./playngo.svg": "1c35",
	"./playson.svg": "fff2",
	"./pragmatic-white.svg": "5403",
	"./pragmatic.svg": "f403",
	"./pragmaticlive.svg": "2310",
	"./promotions_nav.svg": "0aad",
	"./providers.svg": "737e",
	"./pushgaming.svg": "07dd",
	"./qr-app.svg": "a701",
	"./qrcode-app.svg": "83b9",
	"./qrcode.svg": "f146",
	"./quickspin.svg": "3476",
	"./relaxgaming.svg": "5d0a",
	"./settings-app.svg": "fbb4",
	"./settings.svg": "1354",
	"./shield-app.svg": "8bcc",
	"./shield.svg": "7471",
	"./skrill.svg": "306f",
	"./sofort.svg": "fb77",
	"./spinomenal.svg": "d65d",
	"./star-circle.svg": "4739",
	"./step1.svg": "7910",
	"./step2.svg": "ffee",
	"./step3.svg": "21f9",
	"./sthlmgaming.svg": "ac1f",
	"./support.svg": "f0c8",
	"./table.svg": "26c6",
	"./thunderkick.svg": "9922",
	"./ticket.svg": "6485",
	"./toggle.svg": "0b0e",
	"./tournament-circle_nav.svg": "516b",
	"./tournament_nav.svg": "8ede",
	"./truelab.svg": "54b9",
	"./user-profile.svg": "ba02",
	"./user.svg": "f41a",
	"./visa.svg": "6180",
	"./visawhite.svg": "2372",
	"./volt.svg": "30a6",
	"./wazdan.svg": "d722",
	"./webmoney.svg": "a903",
	"./wirecard.svg": "272d",
	"./zimpler.svg": "03de",
	"./zoomIn.svg": "e30d",
	"./zoomOut.svg": "86fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";